export default __webpack_public_path__ + "images/009deed7e408792f0eb3d4b1d4eb04e6.png";